/**
 * Paddle Price ID Mappings
 * Maps price keys to Paddle price IDs with metadata
 */

import type { PaddlePricesConfig } from '../types';

export const PADDLE_PRICES_MAP: PaddlePricesConfig = {
  environment: {
    sandbox: {
      'com.shamruk.velvet.3m80f12w': {
        paddle_id: 'pri_01k8n7yfgvpmrtr3d0cmx2ebjy',
        period: '3m',
        price: 79.99, // USD price in dollars
        trial: '12w',
      },
      'com.shamruk.velvet.3m80f3m': {
        paddle_id: 'pri_01k8n7yfr37vgwb5rvwm2kmwys',
        period: '3m',
        price: 79.99,
        trial: '3m',
      },
      'com.shamruk.velvet.3m60': {
        paddle_id: 'pri_01k8n7yg2ybdgq2n4d7mthtrzh',
        period: '3m',
        price: 59.99,
      },
      'com.shamruk.velvet.m50f1m': {
        paddle_id: 'pri_01k8n7yg9wv62hb9cqhwtw30q6',
        period: 'm',
        price: 49.99,
        trial: '1m',
      },
      'com.shamruk.velvet.m50f1w': {
        paddle_id: 'pri_01k8n7yggee1yvbeg1zgefwp0p',
        period: 'm',
        price: 49.99,
        trial: '1w',
      },
      'com.shamruk.velvet.m50f4w': {
        paddle_id: 'pri_01k8n7ygqv5ks1v5rqe5rby7ht',
        period: 'm',
        price: 49.99,
        trial: '4w',
      },
      'com.shamruk.velvet.m30': {
        paddle_id: 'pri_01k8n7yh9w1009dz2asb8ncsrf',
        period: 'm',
        price: 29.99,
      },
      'com.shamruk.velvet.m40': {
        paddle_id: 'pri_01k8n7yhj02qvbprq9rrhc38rg',
        period: 'm',
        price: 39.99,
      },
      'com.shamruk.velvet.w12': {
        paddle_id: 'pri_01k8n7yhya3pbbp2rwc3m1e6s2',
        period: 'w',
        price: 11.99,
      },
      'com.shamruk.velvet.one1': {
        paddle_id: 'pri_01k8n7yj5y9y6200m8x8h721dw',
        period: 'one',
        price: 0.99,
      },
      'com.shamruk.velvet.one10': {
        paddle_id: 'pri_01k8n7yjf08d5m3c6wt1pzxvgw',
        period: 'one',
        price: 9.99,
      },
      'com.shamruk.velvet.one15': {
        paddle_id: 'pri_01k8n7yjtgwg57bsevrzarmtht',
        period: 'one',
        price: 14.99,
      },
      'com.shamruk.velvet.one2': {
        paddle_id: 'pri_01k8n7ykbq7qw7zdxhc8k71852',
        period: 'one',
        price: 1.99,
      },
      'com.shamruk.velvet.one4': {
        paddle_id: 'pri_01k8n7ymc52qbxjw64n578kkqr',
        period: 'one',
        price: 3.99,
      },
      'com.shamruk.velvet.one7': {
        paddle_id: 'pri_01k8n7ympz5sx3wxrydzs3nqqr',
        period: 'one',
        price: 6.99,
      },
      'one12': {
        paddle_id: 'pri_01kfzcprs2862c2q5r37gy60ms',
        period: 'one',
        price: 11.99,
      },
      'one9': {
        paddle_id: 'pri_01kg0mfh7cm6kn375fm4859wdc',
        period: 'one',
        price: 8.99,
      },
      'com.shamruk.velvet.y40': {
        paddle_id: 'pri_01k8n7yn8b5rr5x0qdx26azgkn',
        period: 'y',
        price: 39.99,
      },
      'com.shamruk.velvet.y120': {
        paddle_id: 'pri_01k8n7ynt4t9sy66ewk9c45ax7',
        period: 'y',
        price: 119.99,
      },
      'com.shamruk.velvet.y130': {
        paddle_id: 'pri_01k8n7yp05xnj0kxr8znek6h1k',
        period: 'y',
        price: 129.99,
      },
      '4w40f1w': {
        paddle_id: 'pri_01kfzc9wdwfft7f9c5kbmdhfsr',
        period: '4w',
        trial: '1w',
        price: 39.99,
      },
      '4w40': {
        paddle_id: 'pri_01kfzcdtp1vdqq8bwzpjxcm76q',
        period: '4w',
        price: 39.99,
      },
      '12w80': {
        paddle_id: 'pri_01kfzcgd9tcq2n0g75ayktxhp2',
        period: '12w',
        price: 79.99,
      },
      '4w30f1w': {
        paddle_id: 'pri_01kg0m9bb28aj5mr8pan48b1xz',
        period: '4w',
        trial: '1w',
        price: 29.99,
      },
      '4w30': {
        paddle_id: 'pri_01kg0mbkkqemr91s5td5662vek',
        period: '4w',
        price: 29.99,
      },
      '12w60': {
        paddle_id: 'pri_01kg0me1wbd1f46pwhg3gka9q9',
        period: '12w',
        price: 59.99,
      },
      discount50: {
        paddle_id: 'dsc_01k8pbras2nxtcrn3w7gwcx3ah',
        type: 'discount',
        percentage: 50,
        description: '50% off promotional discount',
        enabled_for_checkout: false,
      },
      discount67: {
        paddle_id: 'dsc_01k9dng37hmq4h3djp0ce29wva',
        type: 'discount',
        percentage: 66.7,
        description: '67% off promotional discount',
        enabled_for_checkout: false,
      },
    },
    production: {
      'com.shamruk.velvet.3m80f12w': {
        paddle_id: 'pri_01k8n8b6ncr70dpqp761ak4tka',
        period: '3m',
        price: 79.99,
        trial: '12w',
      },
      'com.shamruk.velvet.3m80f3m': {
        paddle_id: 'pri_01k8n8b6wbqq3xs502z4tezvn2',
        period: '3m',
        price: 79.99,
        trial: '3m',
      },
      'com.shamruk.velvet.3m60': {
        paddle_id: 'pri_01k8n8b7305hwv561j273s2yvv',
        period: '3m',
        price: 59.99,
      },
      'com.shamruk.velvet.m50f1m': {
        paddle_id: 'pri_01k8n8b79qexfk6wz2paarj2tg',
        period: 'm',
        price: 49.99,
        trial: '1m',
      },
      'com.shamruk.velvet.m50f1w': {
        paddle_id: 'pri_01k8n8b7fz2v4v1fjqaet02gne',
        period: 'm',
        price: 49.99,
        trial: '1w',
      },
      'com.shamruk.velvet.m50f4w': {
        paddle_id: 'pri_01k8n8b7nvfkn94jr7yymatfvn',
        period: 'm',
        price: 49.99,
        trial: '4w',
      },
      'com.shamruk.velvet.m30': {
        paddle_id: 'pri_01k8n8b7w0zta1r2ctwkxdt7xf',
        period: 'm',
        price: 29.99,
      },
      'com.shamruk.velvet.m40': {
        paddle_id: 'pri_01k8n8b829kpta9qt5p3am8wrz',
        period: 'm',
        price: 39.99,
      },
      'com.shamruk.velvet.w12': {
        paddle_id: 'pri_01k8n8b88b72caycq7g28ey61m',
        period: 'w',
        price: 11.99,
      },
      'com.shamruk.velvet.one1': {
        paddle_id: 'pri_01k8n8b8ecsywha8rv289tdh3p',
        period: 'one',
        price: 0.99,
      },
      'com.shamruk.velvet.one10': {
        paddle_id: 'pri_01k8n8b8mzc4m0h6qm94ethbhx',
        period: 'one',
        price: 9.99,
      },
      'com.shamruk.velvet.one15': {
        paddle_id: 'pri_01k8n8b8vr8t3wdrt4rvchsd13',
        period: 'one',
        price: 14.99,
      },
      'com.shamruk.velvet.one2': {
        paddle_id: 'pri_01k8n8b93b246vxeb88bzmykm2',
        period: 'one',
        price: 1.99,
      },
      'com.shamruk.velvet.one4': {
        paddle_id: 'pri_01k8n8b99ygpqnnsfjz290rjnh',
        period: 'one',
        price: 3.99,
      },
      'com.shamruk.velvet.one7': {
        paddle_id: 'pri_01k8n8b9fre5ytxtqf3pv0swq7',
        period: 'one',
        price: 6.99,
      },
      'one12': {
        paddle_id: 'pri_01kfzcr0z8427ndnp6pbvnvzy0',
        period: 'one',
        price: 11.99,
      },
      'one9': {
        paddle_id: 'pri_01kg0mg709rn2psjfsxfvh8111',
        period: 'one',
        price: 8.99,
      },
      'com.shamruk.velvet.y40': {
        paddle_id: 'pri_01k8n8b9ng9x8c065jh38rvae8',
        period: 'y',
        price: 39.99,
      },
      'com.shamruk.velvet.y60': {
        paddle_id: 'pri_01k8n8b9ve9kdqkyncd2cpk941',
        period: 'y',
        price: 59.99,
      },
      'com.shamruk.velvet.y120': {
        paddle_id: 'pri_01k8n8ba1g4z4642s618s3sws1',
        period: 'y',
        price: 119.99,
      },
      'com.shamruk.velvet.y130': {
        paddle_id: 'pri_01k8n8ba8grgyvbbe934487f3c',
        period: 'y',
        price: 129.99,
      },
      '4w40f1w': {
        paddle_id: 'pri_01kfzcc96h6megncga0bb1sfny',
        period: '4w',
        trial: '1w',
        price: 39.99,
      },
      '4w40': {
        paddle_id: 'pri_01kfzcevqe5k063fx7dcvankjp',
        period: '4w',
        price: 39.99,
      },
      '12w80': {
        paddle_id: 'pri_01kfzchfa2pq4h9110x638w836',
        period: '12w',
        price: 79.99,
      },
      '4w30f1w': {
        paddle_id: 'pri_01kg0ma6gjbxes7ppzzdp7dcb7',
        period: '4w',
        trial: '1w',
        price: 29.99,
      },
      '4w30': {
        paddle_id: 'pri_01kg0mc7g92225rzmhwr20wkdq',
        period: '4w',
        price: 29.99,
      },
      '12w60': {
        paddle_id: 'pri_01kg0memt76c65f6b0bb6q3ev7',
        period: '12w',
        price: 59.99,
      },
      discount50: {
        paddle_id: 'dsc_01k8pbty0mmbvpdqwd3frz0gph',
        type: 'discount',
        percentage: 50,
        description: '50% off promotional discount',
        enabled_for_checkout: false,
      },
      discount67: {
        paddle_id: 'dsc_01k9dnf2qq4nqmamwj3vcsdnww',
        type: 'discount',
        percentage: 66.7,
        description: '67% off promotional discount',
        enabled_for_checkout: false,
      },
    },
  },
};
